/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

import CloseSvg from "@components/icons/close-svg";

type PropsTypeModal = {
  show?: boolean;
  showCloseBtn?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  onEnter?: () => void;
  onExit?: () => void;
  isRewardModal?: boolean;
  isRemoveAdsModal?: boolean;
  isBirthdayRemoveAdsModal?: boolean;
};

function MainModal({
  showCloseBtn,
  children,
  onClick,
  show,
  onEnter,
  onExit,
  isRewardModal,
  isRemoveAdsModal,
  isBirthdayRemoveAdsModal,
}: PropsTypeModal) {
  const [showContent, setShowContent] = useState<boolean>(false);

  const handleEntered = () => {
    if (onEnter) onEnter();
    setShowContent(true);
  };

  const handleExiting = () => {
    setShowContent(false);
  };

  // eslint-disable-next-line no-nested-ternary
  const contentClassName = isRewardModal
    ? "bg-white dark:bg-black text-txt-primary dark:text-txt-dark-primary rounded-t-lg md:rounded-b-lg !overflow-visible relative shadow-modal dark:shadow-modal-dark"
    : isRemoveAdsModal
    ? "bg-black text-white rounded-t-lg md:rounded-b-lg"
    : isBirthdayRemoveAdsModal
    ? "bg-indigo text-white rounded-t-lg md:rounded-b-lg"
    : "bg-white dark:bg-black text-txt-primary dark:text-txt-dark-primary rounded-t-lg md:rounded-b-lg";

  return (
    <Modal
      show={show}
      onHide={onClick}
      container={document.getElementById("root")}
      dialogClassName='modal-dialog-centered modal-dialog-scrollable'
      contentClassName={contentClassName}
      keyboard={false}
      onEnter={handleEntered}
      onExiting={handleExiting}
      onExit={onExit}
    >
      {showContent ? (
        <>
          {showCloseBtn ? (
            <button
              onClick={onClick}
              className='absolute top-4 right-4 z-10 p-1 md:top-6 md:right-6'
              type='button'
            >
              {isBirthdayRemoveAdsModal ? (
                <CloseSvg classNameProps='w-4 h-4' colorFill='fill-white' />
              ) : (
                <CloseSvg classNameProps='w-4 h-4' />
              )}
            </button>
          ) : null}
          {children}
        </>
      ) : null}
    </Modal>
  );
}

export default MainModal;
